module.exports = __webpack_public_path__ + "97d817c4daff027278907622b169d8a4.svg";


//////////////////
// WEBPACK FOOTER
// ./images/social-outlook.svg
// module id = mrUs
// module chunks = 0